<section>
    <div class="signin" *ngIf="showSignin" (click)="hideSignin()">
        <img class="whiteCross" src="assets/img/alerts/iconoir_cancel.png" alt="close" />
        <div class="signinText">
            <p>{{ 'contact.signin' | translate }}</p>
    </div>
    </div>
    <div class="mainFrame">
    <div class="contactMainFrame">
        <div class="leftFrame">
            <div class="contactMe"><p>{{ 'contact.contactMe' | translate }}</p></div>
            <div class="headLine"><p>{{ 'contact.headline' | translate }}</p></div>
            <div class="contactText"><p>{{ 'contact.contactText' | translate }}</p></div>
            <div class="arrow">
                <div class="arrowImg" ><img src="assets/icon/contact/arrowRight.png"></div>
            </div>
        </div>
            <div class="rightFrame">
                <div class="mailForm">
                    <div class="logo">
                        <svg viewBox="0 0 200 200" class="circle-text">
                            <defs>
                                <path id="circlePath" d="M 100, 100 m -75, 0 a 75,75 0 1,1 150,0 a 75,75 0 1,1 -150,0"></path>
                            </defs>
                            <text>
                                <textPath xlink:href="#circlePath" startOffset="50%">
                                    Michael Spari - Frontend Developer Michael Spari - Frontend Developer 
                                </textPath>
                            </text>
                        </svg>
                        <img class="stickerImg" src="assets/icon/contact/sticker.png" alt="Logo Sticker">
                        <img class="logoImage" 
                                    src="assets/logo/logo_ms_en_over.png" alt="logo" 
                                    srcset="" onmouseover="this.src='assets/logo/logo_ms_en.png'" 
                                    onmouseout="this.src='assets/logo/logo_ms_en_over.png'">
                    </div>
                    <div class="leftFrameResponsive">
                        <div class="contactMe"><p>{{ 'contact.contactMe' | translate }}</p></div>
                        <div class="headLine"><p>{{ 'contact.headline' | translate }}</p></div>
                        <div class="contactText"><p>{{ 'contact.contactText' | translate }}</p></div>
                    </div>
                    <div class="contactRows">
                        <form (ngSubmit)="onSubmit(contactForm)" #contactForm="ngForm">
                        <fieldset class="contactFields">
                            <div class="headline"><label for="name">{{ 'contact.name' | translate }}</label></div>
                            <div class="errorMessageContainer">
                                @if (!name.valid && name.touched) {
                                <p class="errorMessage">{{ 'contact.nameerror' | translate}}</p>
                                }
                            </div>
                            <input #name="ngModel" [(ngModel)]="contactData.name" class="contactMeForm__input" type="text"
                                id="name" name="name" placeholder="{{ 'contact.nameplaceholder' | translate}}"
                                required>
                        </fieldset>

                        <fieldset class="contactFields">
                            <div class="headline"><label for="email">{{ 'contact.email' | translate }}</label></div>
                            <div class="errorMessageContainer">
                                @if (!email.valid && email.touched) {
                                <p class="errorMessage">{{ 'contact.emailerror' | translate}}</p>
                                }
                            </div>
                            <input #email="ngModel" [(ngModel)]="contactData.email" class="contactMeForm__input" type="text"
                                id="email" name="email" placeholder="{{ 'contact.emailplaceholder' | translate}}"
                                required pattern="[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}">
                        </fieldset>

                        <fieldset class="contactFields">
                            <div class="headline"><label for="message">{{ 'contact.message' | translate }}</label></div>
                            <div class="errorMessageContainer">
                                @if (!message.valid && message.touched) {
                                <p class="errorMessage">{{ 'contact.messageerror' | translate}}</p>
                                }
                            </div>
                            <input #message="ngModel" [(ngModel)]="contactData.message" class="contactMeForm__input" type="text"
                                id="message" name="message" placeholder="{{ 'contact.messageplaceholder' | translate}}"
                                required>
                        </fieldset>

                        <div class="agreeField">
                            <input type="checkbox" id="agree" class="checkField" name="agree"
                                   [(ngModel)]="isAcceptedPrivacyPolicy">
                            <label class="accept" for="agree">{{ 'contact.privacyPolicy' | translate }}
                                <a routerLink="imprint">{{ 'contact.privacyPolicyLink' | translate }}</a>
                            </label>  
                        </div>
                        <div class="pleaseAccept" *ngIf="!isAcceptedPrivacyPolicy">
                            <p>{{ 'contact.accept' | translate }}</p>
                        </div>
                        <div class="sendButton">
                            <button type="submit" 
                                   class="sendBtn" 
                                   [disabled]="!isAcceptedPrivacyPolicy"
                                   [ngClass]="{ 'disabledBtn': !isAcceptedPrivacyPolicy }">{{ 'contact.send' | translate }}</button>
                        </div>
                        </form>
                    </div>
                </div>
            </div>
    </div>
    <app-footer></app-footer>
</div>
</section>
